module.exports = __webpack_public_path__ + "media/images/emblems/Roemerswil_LU-ab2300fdcb8597eb5158a0ad17882240.png";